export default "https://cdn.questicon.mathletics.com/assets/audio/transitionScreens-f2760bea79c2b5efe6978e2da7ff3d38.mp3";